import { useState } from 'react';
import { Button } from '@/design-system/ui/Button';
import { Icon } from '@/design-system/ui/Icon';
import { Sheet } from '@/design-system/ui/Sheet';
import { toast } from '@/design-system/ui/toast';
import { toApiError } from '@/core/api/errors';
import { downloadLoadFile } from '../api/loads-api';

export function DownloadLoadButton({ loadId }: { loadId: number }) {
  const [busy, setBusy] = useState(false);
  if (!loadId) return null;
  return (
    <Button
      variant="outline"
      size="sm"
      loading={busy}
      icon={<Icon name="download" size={16} />}
      onClick={async () => {
        setBusy(true);
        try {
          await downloadLoadFile(loadId);
        } catch (e) {
          toast.error(toApiError(e).message || 'دانلود ناموفق بود، دوباره تلاش کنید');
        } finally {
          setBusy(false);
        }
      }}
    >
      {busy ? 'در حال دانلود...' : 'دانلود مرسوله'}
    </Button>
  );
}

/** Asks for confirmation first: a driver on the road may not be able to answer. */
export function DriverCallButton({ mobile }: { mobile: string }) {
  const [open, setOpen] = useState(false);
  if (!mobile) return null;
  return (
    <>
      <Button size="sm" icon={<Icon name="phone" size={16} />} onClick={() => setOpen(true)}>تماس با راننده</Button>
      <Sheet open={open} onClose={() => setOpen(false)} title="توجه">
        <p className="mb-5 text-sm leading-loose text-ink-2">
          راننده ممکن است در حال رانندگی باشد یا به تلفن همراه خود دسترسی نداشته باشد، بنابراین امکان دارد پاسخگو نباشد. در صورت لزوم می‌توانید بعداً دوباره تماس بگیرید.
        </p>
        <div className="grid grid-cols-2 gap-3">
          <Button variant="outline" onClick={() => setOpen(false)}>انصراف</Button>
          <Button icon={<Icon name="phone" size={16} />} onClick={() => { setOpen(false); window.location.href = `tel:${mobile}`; }}>تماس</Button>
        </div>
      </Sheet>
    </>
  );
}
